import { React, useState, useEffect, useContext, useMemo } from "react";
import Button from "@mui/material/Button";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { DataGrid, GridActionsCellItem, useGridApiRef } from '@mui/x-data-grid';
import GridNoRow from '../../../../common/GridNoRow';
import axios from "axios";
import Swal from "sweetalert2";
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import styled from "styled-components";
import { AppContext } from '../../../../AppStore';
import Moment from 'moment';
import Select from 'react-select';
import UserSelectModal from "../../../../modal/PC/common/UserSelectModal";
import BOMSelectModal from "../../../../modal/PC/common/BOMSelectModal";
import { useNavigate, useLocation } from "react-router-dom";

const MachineSetting = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const appStore = useContext(AppContext);
    const apiRef = useGridApiRef();
    const [MenuID, setMenuID] = useState(0);
    const [MenuName, setMenuName] = useState('');
    const [MenuUpdateExistYN, setMenuUpdateExistYN] = useState('N');
    const [MenuDeleteExistYN, setMenuDeleteExistYN] = useState('N');
    const [MenuUpdateYN, setMenuUpdateYN] = useState('N');
    const [MenuDeleteYN, setMenuDeleteYN] = useState('N');
    const [rows, setRows] = useState();
    const [columns, setColumns] = useState([]);
    const [userColumns, setUserColumns] = useState([]);
    const [inspectColumns, setInspectColumns] = useState([]);
    const [userRows, setUserRows] = useState([]);
    const [inspectRows, setInspectRows] = useState([]);
    const [updateUserRows, setUpdateUserRows] = useState([]);
    const [updateInspectRows, setUpdateInspectRows] = useState([]);
    const [selectmodalTitle, setSelectModalTitle] = useState('');
    const [isSelectBOMModalOpen, setSelectBOMModalOpen] = useState(false);
    const [isSelectUserModalOpen, setSelectUserModalOpen] = useState(false);
    const [selectUserData, setSelectUserData] = useState('');
    const [userTypeOption, setUserTypeOption] = useState([]);
    const [processOption, setProcessOption] = useState([]);
    const [selectMachineID, setSelectMachineID] = useState('');
    const [rightTab, setRightTab] = useState('manager');
    const [inspectOriginMap, setInspectOriginMap] = useState({});
    const inspectCycleOptions = useMemo(() => ([
        { value:'D', label:'일일'},
        { value:'W', label:'주간'},
        { value:'M', label:'월간'}
    ]), []);
    const [inputs, setInputs] = useState({
        machine_id:0,
        machine_type: 0,
        machine_type_name: '',
        machine_bom_id: 0,
        machine_bom_name: '',
        machine_name:'',
        machine_ip:'',
        machine_port:'',
        machine_location:'',
        machine_comment:'',
    });

    // Grid정의
    const handleSetting = () => {
        setColumns([
            { field: 'id', headerName: 'machine_id', width: 0, headerAlign: 'center' },
            { field: 'machine_name', headerName: '설비명', width: 170, headerAlign: 'center', align:'left' },
            { field: 'machine_type', headerName: 'machine_type', width: 0, headerAlign: 'center' },
            { field: 'machine_type_name', headerName: '설비유형', width: 0, headerAlign: 'center', align:'center' },
            { field: 'machine_bom_id', headerName: 'machine_bom_id', width: 0, headerAlign: 'center' },
            { field: 'machine_bom_name', headerName: '설비BOM', width: 0, headerAlign: 'center', align:'center' },
            { field: 'recent_update_user_name', headerName: '최근수정자', width: 130, headerAlign: 'center', align:'center' },
            { field: 'recent_update_datetime', headerName: '최근수정일시', width: 180, headerAlign: 'center', align:'center' },
            { field: 'machine_ip', headerName: 'machine_ip', width: 0, headerAlign: 'center' },
            { field: 'machine_port', headerName: 'machine_port', width: 0, headerAlign: 'center' },
            { field: 'machine_comment', headerName: 'machine_comment', width: 0, headerAlign: 'center' },
        ]);

        setUserColumns([
                {
                    field: 'actions',
                    headerName: '동작',
                    width: 55,
                    type:'actions',
                    disableClickEventBubbling: true,
                    getActions: (params) => [
                        ((params.row.update_type === "U")? 
                        <GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {userDeleteClick(params)}} label="Delete" />
                        : (params.row.row_type === "A" && params.row.update_type === "N")? 
                        <GridActionsCellItem icon={<AddIcon color="secondary" />} onClick={() => {userAddClick(params)}} label="Add"  /> 
                        :<GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {userDeleteClick(params)}} label="Delete" />
                        )
                    ],
                    headerAlign: 'center', 
                    align:'center'
                } ,
                { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
                { field: 'machine_user_id', headerName: 'machine_user_id', width: 0, headerAlign: 'center' },
                { field: 'machine_user_name', headerName: '담당자명', width: 120, headerAlign: 'center', align:'center' },
                { field: 'machine_user_type', headerName: '담당자유형', type: 'singleSelect', width: 110, 
                valueOptions: () => userTypeOption ?? [], valueFormmatter: ({ value }) => userTypeOption.find((opt) => String(opt.value) === String(value))?.label ?? '',
                editable: true, headerAlign: 'center', align:'center' },
                { field: 'machine_user_phone', headerName: '연락처', width: 150, headerAlign: 'center', align:'center' },
                { field: 'machine_user_bigo', headerName: '비고', width: 500, headerAlign: 'center', align:'left', editable: true },
                { field: 'row_type', headerName: 'row_type', width: 0, headerAlign: 'center' },
                { field: 'update_type', headerName: 'update_type', width: 0, headerAlign: 'center' },
        ]);

        
        // Hide컬럼 숨기기.
        setColumnVisibilityModel({
            id: false,
            machine_name: true,
            machine_type : false,
            machine_type_name: false,
            machine_bom_id : false,
            machine_bom_name: false,
            recent_update_user_name: true,
            recent_update_datetime: true,
            machine_ip: false,
            machine_port: false,
            machine_comment: false,
        });

        setUserColumnVisibilityModel({
            id: false,
            actions: true,
            machine_user_id: false,
            machine_user_name: true,
            machine_user_type: true,
            machine_user_phone: true,
            machine_user_bigo: true,
            row_type: false,
            update_type: false
        });

        setInspectColumns([
            {
                field: 'actions',
                headerName: '동작',
                width: 55,
                type:'actions',
                disableClickEventBubbling: true,
                getActions: (params) => [
                    ((params.row.update_type === "U")? 
                    <GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {inspectDeleteClick(params)}} label="Delete" />
                    : (params.row.row_type === "A" && params.row.update_type === "N")? 
                    <GridActionsCellItem icon={<AddIcon color="secondary" />} onClick={() => {inspectAddClick(params)}} label="Add"  /> 
                    :<GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {inspectDeleteClick(params)}} label="Delete" />
                    )
                ],
                headerAlign: 'center', 
                align:'center'
            },
            { field: 'inspect_id', headerName: 'inspect_id', width: 0, headerAlign: 'center' },
            { field: 'cycle_type', headerName: '주기', type: 'singleSelect', width: 110,
                valueOptions: inspectCycleOptions,
                renderCell: (params) => inspectCycleOptions.find((o) => String(o.value) === String(params.value))?.label ?? '',
                valueFormatter: (value) => inspectCycleOptions.find((o) => String(o.value) === String(value))?.label ?? '',
                editable: true, headerAlign: 'center', align:'center' },
            { field: 'inspect_text', headerName: '점검내용', flex: 1, minWidth: 200, headerAlign: 'center', align:'left', editable: true },
            { field: 'sort_no', headerName: '순서', width: 80, headerAlign: 'center', align:'center', editable: true, type:'number',
                renderCell: (params) => (params.value === '' || params.value === null || params.value === undefined) ? '' : String(params.value),
                valueFormatter: (value) => (value === '' || value === null || value === undefined) ? '' : String(value),
                preProcessEditCellProps: (params) => {
                    const v = params.props.value;
                    const num = Number(v);
                    const isValid = v === '' || (!Number.isNaN(num) && Number.isFinite(num));
                    return { ...params.props, error: !isValid };
                }
            },
            { field: 'inspect_yn', headerName: '점검여부', width: 110, type: 'singleSelect',
                valueOptions: () => ([{ value:'Y', label:'Y'}, { value:'N', label:'N'}]),
                editable: true, headerAlign: 'center', align:'center' },
            { field: 'row_type', headerName: 'row_type', width: 0, headerAlign: 'center' },
            { field: 'update_type', headerName: 'update_type', width: 0, headerAlign: 'center' },
        ]);

        setInspectColumnVisibilityModel({
            actions: true,
            inspect_id: false,
            cycle_type: true,
            sort_no: true,
            inspect_text: true,
            inspect_yn: true,
            row_type: false,
            update_type: false
        });
    }

    const [columnVisibilityModel, setColumnVisibilityModel] = useState({
        id: false,
        machine_name: true,
        machine_type : false,
        machine_type_name: false,
        machine_bom_id : false,
        machine_bom_name: false,
        recent_update_user_name: true,
        recent_update_datetime: true,
        machine_ip: false,
        machine_port: false,
        machine_comment: false,
    });

    const [userColumnVisibilityModel, setUserColumnVisibilityModel] = useState({
        id: false,
        actions: true,
        machine_user_id: false,
        machine_user_name: true,
        machine_user_type: true,
        machine_user_phone: true,
        machine_user_bigo: true,
        row_type: false,
        update_type: false
    });

    const [inspectColumnVisibilityModel, setInspectColumnVisibilityModel] = useState({
        inspect_id: false,
        cycle_type: true,
        sort_no: true,
        inspect_text: true,
        inspect_yn: true,
        row_type: false,
        update_type: false
    });

    useEffect(() => {
        const accessList = JSON.parse(localStorage.getItem("nav"));
        
        if (Array.isArray(accessList) && accessList.filter(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).length > 0) {
            setMenuID(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_id);
            setMenuName(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_name);
            setMenuUpdateExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_exist_yn);
            setMenuDeleteExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_exist_yn);
            setMenuUpdateYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_yn);
            setMenuDeleteYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_yn);
        }else{
            Swal.fire({
                title: '<p style="color:red">접근 권한 오류</p>',
                text: '화면에 접근 권한이 없습니다.',
                confirmButtonText: '확인',
                confirmButtonColor: '#7066e0',
                timer:5000,
                timerProgressBar: true
            }).then((value) => {
                return navigate(-1);
            });
        }
    }, []);
    
    useEffect(() => {
        // 아래의 변수가 변경되면 실행된다. -> 권한체크가 되면 MenuID가 변경되므로, 권한체크 후 Grid 설정.
        if(String(MenuID) !== String(0) && MenuID != null){
            handleInit();
            handleSetting();
            handleView();
        }
    }, [MenuID])

    useEffect(() => {
        setUserColumns([
            {
                field: 'actions',
                headerName: '동작',
                width: 55,
                type:'actions',
                disableClickEventBubbling: true,
                getActions: (params) => [
                        ((params.row.update_type === "U")? 
                        <GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {userDeleteClick(params)}} label="Delete" />
                        : (params.row.row_type === "A" && params.row.update_type === "N")? 
                        <GridActionsCellItem icon={<AddIcon color="secondary" />} onClick={() => {userAddClick(params)}} label="Add"  /> 
                        :<GridActionsCellItem icon={<DeleteIcon color={ "error" } />} onClick={() => {userDeleteClick(params)}} label="Delete" />
                        )
                ],
                headerAlign: 'center', 
                align:'center'
            } ,
            { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
            { field: 'machine_user_id', headerName: 'machine_user_id', width: 0, headerAlign: 'center' },
            { field: 'machine_user_name', headerName: '담당자명', width: 120, headerAlign: 'center', align:'center' },
            { field: 'machine_user_type', headerName: '담당자유형', type: 'singleSelect', width: 110, 
                valueOptions: () => userTypeOption ?? [], valueFormmatter: ({ value }) => userTypeOption.find((opt) => String(opt.value) === String(value))?.label ?? '',
                editable: true, headerAlign: 'center', align:'center' },
            { field: 'machine_user_phone', headerName: '연락처', width: 150, headerAlign: 'center', align:'center' },
            { field: 'machine_user_bigo', headerName: '비고', width: 310, headerAlign: 'center', align:'left', editable: true },
            { field: 'row_type', headerName: 'row_type', width: 0, headerAlign: 'center' },
            { field: 'update_type', headerName: 'update_type', width: 0, headerAlign: 'center' },
        ]);
    }, [userTypeOption]);

    useEffect(() => {
        // userRows가 변경될 때 마지막 Row ADD가 없으면 추가시킨다.
        if(selectMachineID !== ''){
            let ADD_YN= 'Y'
            for(let i=0; i<userRows.length; i++){
                if(userRows[i].row_type === 'A' && userRows[i].update_type === 'N'){
                    ADD_YN = "N"; //마지막 Row update_type = 'N'으로 N유지
                }
            }

            if(ADD_YN === 'Y'){
                setUserRows((userRows) => [...userRows, { 
                    id: Number(appStore.getMaxListID(userRows))+1,
                    machine_user_id: '',
                    machine_user_name: '',
                    machine_user_type: 0,
                    machine_user_phone: '',
                    machine_user_bigo: '',
                    row_type:'A',
                    update_type: 'N'
                }]);
            }
        }
    }, [userRows]);

    useEffect(() => {
        // inspectRows가 변경될 때 마지막 Row ADD가 없으면 추가시킨다.
        if(selectMachineID !== ''){
            let ADD_YN= 'Y'
            for(let i=0; i<inspectRows.length; i++){
                if(inspectRows[i].row_type === 'A' && inspectRows[i].update_type === 'N'){
                    ADD_YN = "N";
                }
            }

            if(ADD_YN === 'Y'){
                setInspectRows((prev) => [...prev, { 
                    id: Number(appStore.getMaxListID(prev))+1,
                    inspect_id: '',
                    cycle_type: 'D',
                    sort_no: '',
                    inspect_text: '',
                    inspect_yn: 'N',
                    machine_id: selectMachineID,
                    row_type:'A',
                    update_type: 'N'
                }]);
            }
        }
    }, [inspectRows]);

    useEffect(() => {
        // 설비 row 선택시 가운데 text 와 담당자 grid 변경
        if(selectMachineID !== ''){
            handleSetup();
        }
    }, [selectMachineID]);

    // Grid 데이터 조회
    const handleView = () => {
        if (appStore.loading) return;
        appStore.setLoading(true);
        
        axios.get('/api/p/MachineSetting/List')
        .then((response) => {
            if(response.status === 200){
                const array = response.data.map((item, index) => ({
                    id: item.machine_id,
                    machine_name:item.machine_name,
                    machine_type:(item.machine_type === undefined)?0:item.machine_type,
                    machine_type_name:(item.machine_type_name === undefined)?"":item.machine_type_name,
                    machine_bom_id:(item.bom_id === undefined)?0:item.bom_id,
                    machine_bom_name:(item.bom_name === undefined)?"":item.bom_name,
                    recent_update_user_name: (item.update_user_name === undefined || item.update_user_name === ''?item.reg_user_name:item.update_user_name),
                    recent_update_datetime: (item.update_datetime === undefined?Moment(item.reg_datetime).format('YYYY-MM-DD HH:mm:ss'):Moment(item.update_datetime).format('YYYY-MM-DD HH:mm:ss')),
                    machine_ip: item.machine_ip,
                    machine_port: item.machine_port,
                    machine_comment: (item.machine_comment === undefined)?"":item.machine_comment
                }));
                setRows(array);
                if(selectMachineID === ''){
                    setSelectMachineID(response.data[0].machine_id);
                }
            }else{
                appStore.capture();
            }
        })
        .catch((error) => {
            appStore.capture();
        })
        .finally(() => {
            appStore.setLoading(false);
        });
    }

    const handleInit = () => {

        // 담당자 유형
        axios.get('/api/Common/CodeDetailList')
        .then((response) => { 
            var user_type_array_modal = [];
            for(let i=0; i<(response.data).length; i++){
                if((response.data)[i].code_id === '0020'){
                    user_type_array_modal.push({ value: (response.data)[i].code_detail_seq, label: (response.data)[i].code_detail_name });
                }
            }
            setUserTypeOption(user_type_array_modal);
        })
        .catch((error) => {
            console.log(error);
        });

        //공정
        axios.get('/api/Common/ProcessList')
        .then((response) => {
            var array = response.data.map((item, index) => 
                ({ value: item.process_id, label: item.process_name })
            );
            array.unshift({ value: 0, label : '설비공정'});
            setProcessOption(array);
        })
        .catch((error) => {
            console.log(error);
        });
    };

    const handleSetup = () => {
        setInspectRows([]);
        setUpdateInspectRows([]);
        setInspectOriginMap({});
        for(let i=0; i<rows.length; i++){
            if(rows[i].id === selectMachineID){
                setInputs({
                    machine_id:rows[i].id,
                    machine_name:rows[i].machine_name,
                    machine_type:rows[i].machine_type,
                    machine_type_name:rows[i].machine_type_name,
                    machine_bom_id:rows[i].machine_bom_id,
                    machine_bom_name:rows[i].machine_bom_name,
                    machine_ip:rows[i].machine_ip,
                    machine_port:rows[i].machine_port,
                    machine_comment:rows[i].machine_comment
                })
            }
        }

        axios.get('/api/p/MachineSetting/ManagerList',
            {
                params : {
                    machine_id : selectMachineID
                }
            },
            { withCredentials: true }
        )
        .then((response) => {
            if(response.status === 200){
                const array = response.data.map((item, index) => ({
                    id: item.machine_user_seq,
                    machine_user_id: item.machine_user_id,
                    machine_user_name: item.machine_user_name,
                    machine_user_type: item.machine_user_type,
                    machine_user_phone: item.machine_user_phone,
                    machine_user_bigo: item.machine_user_bigo,
                    row_type: 'O',
                    update_type: 'N'
                }));
                setUserRows(array);
            }else{
                appStore.capture();
            }
        })
        .catch((error) => {
            appStore.capture();
        });

        axios.get('/api/p/MachineSetting/InspectList',
            {
                params : {
                    machine_id : selectMachineID
                }
            },
            { withCredentials: true }
        )
        .then((response) => {
            if(response.status === 200){
                const array = response.data.map((item, index) => ({
                    id: item.inspect_id,
                    inspect_id: item.inspect_id,
                    cycle_type: item.cycle_type ?? 'D',
                    sort_no: (item.sort_no === undefined || item.sort_no === null) ? '' : Number(item.sort_no),
                    inspect_text: item.inspect_text,
                    inspect_yn: item.inspect_yn ?? 'N',
                    machine_id: selectMachineID,
                    row_type: 'O',
                    update_type: 'N'
                }));
                const originMap = {};
                array.forEach((row) => { originMap[row.inspect_id] = row.inspect_yn; });
                setInspectOriginMap(originMap);
                setInspectRows(array);
                setUpdateInspectRows([]);
        }else{
            appStore.capture();
        }
    })
    .catch((error) => {
        console.log(error);
        Swal.fire({
            title: '<p style="color:red">설비 설정 저장 오류</p>',
            html: '정상적으로 저장하지 못했습니다.<br/>다시 시도해 주세요.',
            confirmButtonText: '확인'
        });
        appStore.capture();
    });
    }

    const userAddClick = (object) => {
        //설비 담당자 추가 버튼
        let ADD_YN= 'Y'
        for(let i=0; i<userRows.length; i++){
            if(userRows[i].row_type === 'A' && userRows[i].update_type === 'N'){
                ADD_YN = "N"; //마지막 Row update_type = 'N'으로 N유지
            }
        }

        if(ADD_YN === 'Y'){
            setUserRows((userRows) => [...userRows, { 
                id: Number(appStore.getMaxListID(userRows))+1,
                machine_user_id: '',
                machine_user_name: '',
                machine_user_type: 0,
                machine_user_phone: '',
                machine_user_bigo: '',
                row_type:'A',
                update_type: 'N'
            }]);
        }
    };

    const userDeleteClick = (object) => {
        //설비 담당자 삭제 버튼
        setUpdateUserRows((updateUserRows) => updateUserRows.filter((data) => data.id !== object.row.id));
        if(object.row.row_type === 'O'){
          setUpdateUserRows(prevRows => [...prevRows, {
            id: object.row.id,
            machine_user_id: object.row.machine_user_id,
            machine_user_name: object.row.machine_user_name,
            machine_user_type: object.row.machine_user_type,
            machine_user_phone: object.row.machine_user_phone,
            machine_user_bigo: object.row.machine_user_bigo,
            row_type:'O',
            update_type: 'D'
          }]);
        }
        setUserRows((userRows) => userRows.filter((data) => data.id !== object.row.id));
    };

    const inspectAddClick = () => {
        let ADD_YN= 'Y'
        for(let i=0; i<inspectRows.length; i++){
            if(inspectRows[i].row_type === 'A' && inspectRows[i].update_type === 'N'){
                ADD_YN = "N";
            }
        }
        if(ADD_YN === 'Y'){
            setInspectRows((prev) => [...prev, {
                id: Number(appStore.getMaxListID(prev))+1,
                inspect_id: '',
                cycle_type: 'D',
                cycle_type_name: '일일',
                inspect_text: '',
                inspect_yn: 'N',
                row_type:'A',
                update_type: 'N'
            }]);
        }
    };

    const inspectDeleteClick = (object) => {
        setUpdateInspectRows((prev) => prev.filter((data) => data.id !== object.row.id && data.inspect_id !== object.row.inspect_id));
        if(object.row.row_type === 'O'){
            setUpdateInspectRows(prevRows => [...prevRows, {
                ...object.row,
                machine_id: selectMachineID,
                update_type: 'D'
            }]);
        }
        setInspectRows((prev) => prev.filter((data) => data.id !== object.row.id));
    };

    const handleSave = () => {
        // 이름 확인 정규식(2-20 자리 영문소+영문대+한글+띄어쓰기 입력 가능) : !(/^[가-힣a-zA-z\s]{2,20}$/).test(inputs.user_name.trim())
        // 날짜 확인 정규식(19@@년도 입력 불가) : !(/^2[0-1]\d{2}-(0[0-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$/).test(inputs.user_start_date.trim())
        // 날짜 확인 정규식(19@@년도 입력 가능) : !(/^(19\d{2}|2[0-1]\d{2})-(0[0-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$/).test(inputs.user_start_date.trim())
        // 휴대폰 정규식(010-숫자4자리-숫자4자리 입력 가능) : !(/^010-\d{4}-\d{4}$/).test(inputs.user_phone.trim())
        // 전화번호 정규식(숫자3자리-숫자4자리-숫자4자리) : !(/^\d{3}-(\d{3,4})-\d{4}$/).test(inputs.user_call.trim())
        // E-Mail 정규식 : !(/^[-A-Za-z0-9_]+[-A-Za-z0-9_.]*[@]{1}[-A-Za-z0-9_]+[-A-Za-z0-9_.]*[.]{1}[A-Za-z]{1,5}$/).test(inputs.user_email.trim())
        // 계좌번호 정규식(숫자, 하이픈 5-30자리 이하) : !(/^[0-9-]{5,30}$/).test(inputs.bank_number.trim())
        let msg = '';
        if(selectMachineID.machine_id === ''){
            msg = '설비를 선택해주세요.'
        }
        if(inputs.machine_name.trim() === '' || inputs.machine_name.trim() === 0){
            msg = '설비명은 필수 입력 입니다.'
        }
        // 설비담당자 검사
        if(updateUserRows.length > 0 && msg === ''){
            for(let i = 0; i < updateUserRows.length; i++) {
                const machine_user_id = updateUserRows[i].machine_user_id;
                const machine_user_type = updateUserRows[i].machine_user_type;
                
                if(machine_user_id === 0 || machine_user_id === '') {
                    msg = '선택되지 않은 담당자명이 존재합니다.';
                    break;
                }
                if(machine_user_type === 0 || machine_user_type === '') {
                    msg = '선택되지 않은 담당자유형이 존재합니다.';
                    break;
                }
            }
        }
        // 점검표 신규/수정 검사
        if(updateInspectRows.length > 0 && msg === ''){
            for(let i = 0; i < updateInspectRows.length; i++) {
                const row = updateInspectRows[i];
                if(row.row_type === 'A' || row.update_type === 'U'){
                    if((row.inspect_text ?? '').trim() === ''){
                        msg = '점검내용을 입력해주세요.';
                        break;
                    }
                    if(!row.cycle_type || row.cycle_type === ''){
                        msg = '점검 주기를 선택해주세요.';
                        break;
                    }
                    if(!row.inspect_yn || row.inspect_yn === ''){
                        msg = '점검여부를 선택해주세요.';
                        break;
                    }
                }
            }
        }

        if(msg !== ''){
            Swal.fire({
                title: '<p style="color:red">설비 설정 저장 오류</p>',
                html: msg,
                confirmButtonText: '확인'
            });
        }else{
            console.log({inputs, updateUserRows, updateInspectRows, selectMachineID});
            axios.post("/api/p/MachineSetting/Reg", {inputs, updateUserRows, updateInspectRows, selectMachineID} ,
            { withCredentials: true })
            .then(function (response) {
                if(response.status === 200){
                    Swal.fire({
                        title: '설비 설정 저장 완료',
                        text: '정상적으로 설비 설정이 저장 되었습니다.',
                        confirmButtonText: '확인',
                        timer:5000,
                        timerProgressBar: true
                    }).then((result) => {
                        handleView();
                        // 저장 후 현재 설비의 담당자/점검표 재조회
                        if(selectMachineID){
                            handleSetup();
                        }
                    });
                }else{
                    appStore.capture();
                }
            })
            .catch(function (error) {
                appStore.capture();
            });
        }
    };

    const onChange = (e)=>{
        const {name, value} = e.target;
        const nextInputs = {
            ...inputs,
            [name]: value, 
        };
        setInputs(nextInputs);
    };

    const onSelectChange = (type, value) => {
        const nextInputs = {
            ...inputs,
            [type] : value
        };
        setInputs(nextInputs);
    };

    const handleOnCellClick = (params) => {
        if(params.field === 'machine_user_name'){
          setSelectModalTitle('사용자 목록')
          setSelectUserModalOpen(true);
          setSelectUserData({
            id: params.row.id,
            machine_user_id: params.row.machine_user_id,
            machine_user_name: params.row.machine_user_name,
            machine_user_type: params.row.machine_user_type,
            machine_user_phone: params.row.machine_user_phone,
            machine_user_bigo: params.row.machine_user_bigo,
            row_type: params.row.row_type,
            update_type: params.row.update_type
          })
        }
    };

    const handleBOMInputClick = () => {
        setSelectModalTitle('BOM 목록')
        setSelectBOMModalOpen(true);
    };

    const handleBOMClick = (object) => {
        setInputs({
            ...inputs,
            'machine_bom_id':object.id,
            'machine_bom_name':object.bom_name,
        })
    };

    const handleUserClick = (object) => {
        //사용자목록 모달에서 클릭한 값으로 담당자 데이터 설정함.
        var doubleYN = 'N' 
        for(let i = 0; i < userRows.length; i++){
          if(userRows[i].machine_user_id === object.id && selectUserData.id !== userRows[i].id && object.id !== ''){
            doubleYN = 'Y'
          }
        }
        if(doubleYN === 'Y'){
          Swal.fire({
            title: '<p style="color:red">담당자 '+object.user_name+' 중복</p>',
            text: '추가된 담당자이므로, 중복으로 추가할 수 없습니다.',
            confirmButtonText: '확인'
          });
        } else {
          if(object.id !== selectUserData.machine_user_id){
            processUserRowUpdate(
              {
                id : selectUserData.id,
                machine_user_id: object.id,
                machine_user_name: object.user_name,
                machine_user_type: (selectUserData.machine_user_type === 0 || selectUserData.machine_user_type === '') ? 178 : selectUserData.machine_user_type,
                machine_user_phone: object.user_phone,
                machine_user_bigo: selectUserData.machine_user_bigo,
                row_type: selectUserData.row_type,
                update_type: selectUserData.update_type
              },
              {
                id : selectUserData.id,
                machine_user_id: selectUserData.machine_user_id,
                machine_user_name: selectUserData.machine_user_name,
                machine_user_type: (selectUserData.machine_user_type === 0 || selectUserData.machine_user_type === '') ? 178 : selectUserData.machine_user_type,
                machine_user_phone: selectUserData.machine_user_phone,
                machine_user_bigo: selectUserData.machine_user_bigo,
                row_type: selectUserData.row_type,
                update_type: selectUserData.update_type
              }
            )
          }
        }
    };

    const processUserRowUpdate = (newRow, oldRow) => {
        //자원 담당자 Rows Update
        const newUpdateDataArray = { ...newRow, update_type: 'U' }; // 값 변경이 있는 경우
        const newNoDataArray = { ...newRow, update_type: 'N' }; // 값 변경이 없는 경우

        if(oldRow.machine_user_id !== newRow.machine_user_id || oldRow.machine_user_type !== newRow.machine_user_type || oldRow.machine_user_bigo !== newRow.machine_user_bigo){
          // 기존Row와 변경Row가 동일하면 그냥 넘어간다. 이럴경우에도 호출됨.
          var row_machine_user_id = '';
          var row_machine_user_name = '';
          var row_machine_user_type = 0;
          var row_machine_user_bigo = '';
          
          if(String(newRow.row_type) === "A"){
            //console.log('originRows는 추가된 ROW를 못 인식함. -> 따라서 입력된 값이 있는지를 판단해야함.')
            if(newRow.machine_user_id !== '' || newRow.machine_user_name !== '' || (newRow.machine_user_type !== 0 && newRow.machine_user_type !== '' && newRow.machine_user_type !== null) || newRow.machine_user_bigo !== '' ){
              row_machine_user_id = newRow.machine_user_id;
              row_machine_user_name = newRow.machine_user_name;
              row_machine_user_type = newRow.machine_user_type;
              row_machine_user_bigo = newRow.machine_user_bigo;
            }
          }else{
            // 추가 아닌 ROW는 originRows과 비교해야함.
            //console.log('추가 아닌 ROW는 originRows과 비교해야함.')
            userRows.map((data) => data.id === newRow.id 
              && (data.machine_user_id !== newRow.machine_user_id || data.machine_user_name !== newRow.machine_user_name || data.machine_user_type !== newRow.machine_user_type || data.machine_user_bigo !== newRow.machine_user_bigo )?
              (
                row_machine_user_id = data.machine_user_id,
                row_machine_user_name = data.machine_user_name,
                row_machine_user_type = data.machine_user_type,
                row_machine_user_bigo = data.machine_user_bigo
              ):""
            )
          }
          
          if(row_machine_user_id === '' && row_machine_user_name === '' && row_machine_user_bigo === '' && (row_machine_user_type === 0 || row_machine_user_type === '' || row_machine_user_type === null)){
            // 1. 값이 수정되지 않은 경우.
            if(updateUserRows.length > 0){
              // 원복된 값이므로 updateRow는 값을 삭제 해야하고, rows는 update_type = 'N'으로 변경하고 값을 Update해야함. 
              //console.log('[updateRows 원복] ' + updateUserRows.length);
              setUpdateUserRows(updateUserRows.filter((data) => data.id !== newRow.id));
              setUserRows(userRows.map((data) => data.id === newRow.id? newNoDataArray : data ));
            }
            return newNoDataArray;
          }else{
            // 2. 값이 수정된 경우.
            var updateRowsYN = 'N'; //updateRows에 있는값인지 확인함.
            for (let i = 0; i < updateUserRows.length; i++) {
            if(updateUserRows[i].id === newRow.id){
                updateRowsYN = 'Y';
            }
            }

            if(updateRowsYN === 'Y'){
            //console.log('['+newRow.id+'][updateRows에 동일한ID의 추가 변경된 값이 있는 경우] ' + updateUserRows.length);
            setUpdateUserRows(updateUserRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
            setUserRows(userRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
            }else{
            //console.log('['+newRow.id+'][updateRows에 없는 newRow가 추가인 경우] ' + updateUserRows.length);
            setUpdateUserRows(prevRows => [...prevRows, newUpdateDataArray]);
            setUserRows(userRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
            }
            return newUpdateDataArray;
          }
        }
        return { ...newRow };
    };

    const processInspectRowUpdate = (newRow, oldRow) => {
        // 점검표 Rows Update (processUserRowUpdate와 동일한 패턴)
        const newUpdateDataArray = { ...newRow, update_type: 'U' }; // 값 변경이 있는 경우
        const newNoDataArray = { ...newRow, update_type: 'N' }; // 값 변경이 없는 경우

        if(
          oldRow.inspect_text !== newRow.inspect_text ||
          oldRow.inspect_yn !== newRow.inspect_yn ||
          oldRow.cycle_type !== newRow.cycle_type ||
          oldRow.sort_no !== newRow.sort_no
        ){
          // 기존Row와 변경Row가 동일하면 그냥 넘어간다. 이럴경우에도 호출됨.
          var row_inspect_id = '';
          var row_inspect_text = '';
          var row_inspect_yn = '';
          var row_cycle_type = '';
          var row_sort_no = '';
          
          if(String(newRow.row_type) === "A"){
            // 추가된 ROW는 입력된 값이 있는지를 판단
            if(
                (newRow.inspect_id !== '' && newRow.inspect_id !== null)
                || (newRow.inspect_text !== '' && newRow.inspect_text !== null)
                || (newRow.inspect_yn !== '' && newRow.inspect_yn !== null)
                || (newRow.cycle_type !== '' && newRow.cycle_type !== null)
                || (newRow.sort_no !== '' && newRow.sort_no !== null)
            ){
              row_inspect_id = newRow.inspect_id;
              row_inspect_text = newRow.inspect_text;
              row_inspect_yn = newRow.inspect_yn;
              row_cycle_type = newRow.cycle_type;
              row_sort_no = newRow.sort_no;
            }
          }else{
            // 추가 아닌 ROW는 originRows과 비교해야함.
            inspectRows.map((data) => data.id === newRow.id 
              && (data.inspect_id !== newRow.inspect_id || data.inspect_text !== newRow.inspect_text || data.inspect_yn !== newRow.inspect_yn || data.cycle_type !== newRow.cycle_type || data.sort_no !== newRow.sort_no)?
              (
                row_inspect_id = data.inspect_id,
                row_inspect_text = data.inspect_text,
                row_inspect_yn = data.inspect_yn,
                row_cycle_type = data.cycle_type,
                row_sort_no = data.sort_no
              ):""
            )
          }
          
          if(
            (row_inspect_id === '' || row_inspect_id === null)
            && (row_inspect_text === '' || row_inspect_text === null)
            && (row_inspect_yn === '' || row_inspect_yn === null)
            && (row_cycle_type === '' || row_cycle_type === null)
            && (row_sort_no === '' || row_sort_no === null)
          ){
            // 1. 값이 수정되지 않은 경우.
            if(updateInspectRows.length > 0){
              // 원복된 값이므로 updateRow는 값을 삭제 해야하고, rows는 update_type = 'N'으로 변경하고 값을 Update해야함. 
              setUpdateInspectRows(updateInspectRows.filter((data) => data.id !== newRow.id));
              setInspectRows(inspectRows.map((data) => data.id === newRow.id? newNoDataArray : data ));
            }
            return newNoDataArray;
          }else{
            // 2. 값이 수정된 경우.
            var updateRowsYN = 'N'; //updateRows에 있는값인지 확인함.
            for (let i = 0; i < updateInspectRows.length; i++) {
            if(updateInspectRows[i].id === newRow.id){
                updateRowsYN = 'Y';
            }
            }

            if(updateRowsYN === 'Y'){
            setUpdateInspectRows(updateInspectRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
            setInspectRows(inspectRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
            }else{
            setUpdateInspectRows(prevRows => [...prevRows, newUpdateDataArray]);
            setInspectRows(inspectRows.map((data) => data.id === newRow.id? newUpdateDataArray : data ));
            }
            return newUpdateDataArray;
          }
        }
        return { ...newRow };
    };

    const handleRightTabChange = (event, newValue) => {
        setRightTab(newValue);
    };

    return (
        <div style={ { width:'100%', display: String(MenuID) === String(0) ? 'hidden' : 'block' } }>
            <div className="menubox" style={ { height: '70px', paddingRight: '0px' } }>
                <div className="menu-action" style={ { paddingRight: '0px' } }>
                    <div className="menu-title">{ MenuName }</div>
                    <div className="menu-button">
                        <Button 
                            onClick={ handleSave }
                            className="btn-p btn-u"
                            sx={{  
                                m: 1, 
                                fontSize: 15, 
                                color: "white", 
                                borderColor: "#FF3636", 
                                backgroundColor: "#FF3636",
                                ":hover": { boxShadow: "2px 2px 2px #FF3636" , backgroundColor: "#FF3636", borderColor: "#FF3636"}
                            }} 
                            variant="outlined">
                            저장
                        </Button>
                    </div>
                </div>
            </div>
            <div className="grid" style={{top:'72px', overflow:'unset'}}>
                <div style={ {  width: '100%' } }>
                    <div className="grid_sub" style={ {  width: '510px', float: 'left', height: 'calc(100vh - 173px)', fontSize: '17px' } }>
                        <DataGrid
                            className="grid_main"
                            rows={rows}
                            columns={columns}
                            slots={{
                                noRowsOverlay: GridNoRow,
                            }}
                            columnVisibilityModel={columnVisibilityModel}
                            onRowSelectionModelChange={(newSelectedIds) => {
                                setSelectMachineID(newSelectedIds[0]);
                            }}
                            selectedIds={selectMachineID}
                            AlternatingRowBackground="LavenderBlush"
                            rowsPerPageOptions={[20, 50, 100]}
                        />
                    </div>
                    <div className="grid_sub" style={ { width: '460px', float: 'left', border: '1px solid rgb(211, 211, 211)', borderRadius:'5px', marginLeft:'5px', height: 'calc(100vh - 173px)' } }>
                    
                        <div className="modal" style={{height: '100%'}}>
                            <table className="ModalTABLE" style={{width:'35%'}}>
                                <tbody>
                                    <tr>
                                        <td className="ModalTD" style={{paddingLeft:'10px'}}>
                                            <div className="modal_filed">
                                                <div className="modal_filed_title">설비명<span className="essential">*</span></div>
                                                <div className="modal_filed_input">
                                                <input type="text" placeholder="설비명" value={inputs.machine_name} name="machine_name" onChange={(e) => onChange(e) } autoComplete="off" />
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="ModalTD" style={{paddingLeft:'10px'}}>
                                            <div className="modal_filed">
                                                <div className="modal_filed_title">설비유형</div>
                                                <div className="modal_filed_input">
                                                    <input type="text" placeholder="설비유형" value={inputs.machine_type_name} name="machine_name" onChange={(e) => onChange(e) } autoComplete="off" disabled />
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="ModalTD" style={{paddingLeft:'10px'}}>
                                            <div className="modal_filed">
                                                <div className="modal_filed_title">설비IP</div>
                                                <div className="modal_filed_input">
                                                <input type="text" placeholder="설비IP" value={inputs.machine_ip} name="machine_ip" onChange={(e) => onChange(e) } autoComplete="off" disabled/>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    {String(inputs?.machine_type) !== '1' && (
                                    <tr>
                                        <td className="ModalTD" style={{paddingLeft:'10px'}}>
                                            <div className="modal_filed">
                                                <div className="modal_filed_title">설비BOM</div>
                                                <div className="modal_filed_input">
                                                <input type="text" placeholder="설비BOM" value={inputs.machine_bom_name} name="machine_bom_name" onChange={(e) => onChange(e) } autoComplete="off" style={{cursor:'pointer'}} onClick={()=> handleBOMInputClick() } readOnly />
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    )}
                                    <tr>
                                        <td className="ModalTD" style={{paddingLeft:'10px'}}>
                                            <div className="modal_filed">
                                                <div className="modal_filed_title">설비설명</div>
                                                <div className="modal_filed_input">
                                                <input type="text" placeholder="설비설명" value={inputs.machine_comment} name="machine_comment" onChange={(e) => onChange(e) } autoComplete="off" />
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    
                    </div>
                    <div className="grid_sub" style={ { width: 'calc(100% - 980px)', float: 'right', height: 'calc(100vh - 173px)', fontSize: '17px', display: 'flex', flexDirection: 'column', overflow: 'hidden' } }>
                        <Tabs
                            value={rightTab}
                            onChange={handleRightTabChange}
                            sx={{ minHeight: 44, borderBottom: '1px solid #e5e7eb' }}
                        >
                            <Tab value="manager" label="담당자" sx={{ minHeight: 44 }} />
                            <Tab value="inspection" label="점검표" sx={{ minHeight: 44 }} />
                        </Tabs>
                        {rightTab === 'manager' && (
                            <div style={{ flex: 1, minHeight: 0 }}>
                                <DataGrid
                                    className="grid_main"
                                    rows={userRows}
                                    columns={userColumns}
                                    columnVisibilityModel={userColumnVisibilityModel}
                                    editMode='cell'  
                                    processRowUpdate={processUserRowUpdate}        
                                    onProcessRowUpdateError={(error) => error}
                                    AlternatingRowBackground="LavenderBlush"
                                    rowsPerPageOptions={[20, 50, 100]}
                                    slots={{
                                        noRowsOverlay: GridNoRow,
                                    }}
                                    onCellClick={handleOnCellClick}
                                    disableColumnSorting 
                                />
                            </div>
                        )}
                        {rightTab === 'inspection' && (
                            <div style={{ flex: 1, minHeight: 0 }}>
                                <DataGrid
                                    className="grid_main"
                                    rows={inspectRows}
                                    columns={inspectColumns}
                                    columnVisibilityModel={inspectColumnVisibilityModel}
                                    editMode='cell'
                                    processRowUpdate={processInspectRowUpdate}
                                    onProcessRowUpdateError={(error) => error}
                                    AlternatingRowBackground="LavenderBlush"
                                    rowsPerPageOptions={[20, 50, 100]}
                                    slots={{
                                        noRowsOverlay: GridNoRow,
                                    }}
                                    disableColumnSorting
                                />
                            </div>
                        )}
                    </div>
                    {isSelectBOMModalOpen && (<BOMSelectModal
                        onClose={() => {
                            setSelectBOMModalOpen(false);
                        }}
                        title={selectmodalTitle}
                        handleBOMClick={handleBOMClick}
                        />)}
                        
                    {isSelectUserModalOpen && (<UserSelectModal
                        onClose={() => {
                            setSelectUserModalOpen(false);
                        }}
                        title={selectmodalTitle}
                        handleUserClick={handleUserClick}
                    />)}
                </div>
            </div>
        </div>
    )
}

const AppWrap = styled.div`
  text-align: center;
  margin: 50px auto;
`;

export default MachineSetting;
